// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"18cc32e1","239":"4925bedf","453":"641ca110","455":"4a200f88","608":"ad580b1f","652":"06202a72","680":"b42eafa0","912":"811d422b"}[chunkId] + ".chunk.js";
};